// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3ZBkY","inner":"Footer_inner__LSpcP","nextIcon":"Footer_nextIcon__3teYq","innerLeft":"Footer_innerLeft__tD8Rz"};